import React from 'react';
import { Files, Download, Edit, Check, Trash2 } from 'lucide-react';
import { contratosApi } from '../../../lib/api';
import { formatCurrency, cn, formatDate } from '../../../lib/utils';
import { Button } from '../../ui/button';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from '../../ui/dialog';

export const BorradoresDialog = ({
  open,
  onOpenChange,
  borradores,
  saving,
  handleEditBorrador,
  handleAprobarBorrador,
  handleDescartarBorrador,
}) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-3xl max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Files className="w-5 h-5 text-amber-600" />
            Borradores Pendientes de Revisión ({borradores.length})
          </DialogTitle>
        </DialogHeader>

        <div className="space-y-3">
          {borradores.length === 0 ? (
            <p className="text-center text-slate-500 py-8">No hay borradores pendientes</p>
          ) : (
            borradores.map((borrador) => (
              <div
                key={borrador.borrador_id}
                className="border border-slate-200 rounded-lg p-4 space-y-3"
              >
                <div className="flex items-start justify-between">
                  <div className="flex-1">
                    <div className="flex items-center gap-2 mb-1">
                      <span className="font-medium text-slate-900">
                        {borrador.razon_social || borrador.nombre_comercial || 'Sin inquilino detectado'}
                      </span>
                      <span className={cn(
                        "text-xs px-2 py-0.5 rounded-full",
                        borrador.confianza === 'alta' ? "bg-green-100 text-green-700" :
                        borrador.confianza === 'media' ? "bg-amber-100 text-amber-700" :
                        "bg-red-100 text-red-700"
                      )}>
                        Confianza: {borrador.confianza || 'baja'}
                      </span>
                    </div>
                    <p className="text-sm text-slate-500">
                      Archivo: {borrador.archivo_nombre}
                    </p>
                  </div>
                  {borrador.archivo_id && (
                    <Button
                      variant="ghost"
                      size="sm"
                      onClick={() => window.open(contratosApi.downloadArchivo(borrador.archivo_id), '_blank')}
                    >
                      <Download className="w-4 h-4" />
                    </Button>
                  )}
                </div>

                <div className="grid grid-cols-2 md:grid-cols-4 gap-3 text-sm">
                  <div>
                    <p className="text-slate-500">Unidad</p>
                    <p className={cn("font-medium", !borrador.unidad_nombre && "text-amber-600")}>
                      {borrador.unidad_nombre || borrador.unidad_detectada || '⚠️ Sin asignar'}
                    </p>
                  </div>
                  <div>
                    <p className="text-slate-500">Monto</p>
                    <p className="font-medium">
                      {borrador.monto_inicial ? formatCurrency(borrador.monto_inicial, borrador.moneda) : '-'}
                    </p>
                  </div>
                  <div>
                    <p className="text-slate-500">Inicio</p>
                    <p className="font-medium">{formatDate(borrador.fecha_inicio)}</p>
                  </div>
                  <div>
                    <p className="text-slate-500">Fin</p>
                    <p className="font-medium">{formatDate(borrador.fecha_fin)}</p>
                  </div>
                </div>

                <div className="flex items-center gap-2 pt-2 border-t border-slate-100">
                  <Button
                    variant="outline"
                    size="sm"
                    onClick={() => handleEditBorrador(borrador)}
                  >
                    <Edit className="w-4 h-4 mr-1" />
                    Editar
                  </Button>
                  <Button
                    size="sm"
                    onClick={() => handleAprobarBorrador(borrador)}
                    disabled={saving}
                    className="bg-green-600 hover:bg-green-700"
                  >
                    <Check className="w-4 h-4 mr-1" />
                    Aprobar
                  </Button>
                  <Button
                    variant="ghost"
                    size="sm"
                    onClick={() => handleDescartarBorrador(borrador)}
                    disabled={saving}
                    className="text-red-600 hover:text-red-700 hover:bg-red-50"
                  >
                    <Trash2 className="w-4 h-4 mr-1" />
                    Descartar
                  </Button>
                </div>
              </div>
            ))
          )}
        </div>

        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Cerrar
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
